import { render } from "./BarcodeLinkingDialog.vue?vue&type=template&id=39086030&scoped=true"
import script from "./BarcodeLinkingDialog.vue?vue&type=script&lang=ts"
export * from "./BarcodeLinkingDialog.vue?vue&type=script&lang=ts"

import "./BarcodeLinkingDialog.vue?vue&type=style&index=0&id=39086030&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-39086030"

export default script